import React, { memo } from 'react';
import { log } from 'utils';
import PanelStockOverView from './panelStockOverview';
import PanelStockSummary from './panelStockSummary';
import PanelStockTradeHistory from './panelStockTradeHis';
import * as _ from 'lodash'

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function OverviewStock(props) {
  const abortController = new AbortController();
  const [tabActive, setTabActive] = React.useState('Tong-Hop');
  const [topShow, setTopShow] = React.useState([]);
  const [stockRealShow, setStockRealShow] = React.useState(null)

  const { stockDetail, basicInfo, t, theme, algoSChart } = props;
  const preCompanyID = usePrevious(stockDetail?.CompanyID);
  const preAlgoSChart = usePrevious(algoSChart);
  const symRef = React.useRef(null);

  // React.useEffect(() => {
  //   if (tabActive) {
  //     // load history trade
  //     getTopMatch();
  //   }
  // }, [tabActive]);

  React.useEffect(() => {
    if (stockDetail?.CompanyID && stockDetail?.CompanyID !== preCompanyID) {
      symRef.current = stockDetail?.CompanyID;
      getTopMatch();
    }
  }, [stockDetail?.CompanyID]);

  React.useEffect(() => {
    if (
      algoSChart &&
      !_.isEqual(algoSChart, preAlgoSChart) &&
      algoSChart[0] === stockDetail?.CompanyID
    ) {
      setStockRealShow(algoSChart)
      // settopshow
      setTopShow([
        {
          Time: algoSChart[1],
          PriceChange: algoSChart[3],
          MatchPrice: algoSChart[2],
          MatchVolume: algoSChart[4],
          OrderType: algoSChart[7],
          TotalBuyVolume: algoSChart[11],
          TotalSellVolume: algoSChart[12],
          BuyForeignValue: algoSChart[13],
        },
        ...topShow,
      ])
    }
  }, [algoSChart])

  function getTopMatch() {
    if(!symRef.current) return;
    setTopShow([])
    fetch(
      appUrl + 'pbapi/api/stockBoard/chart/stock/' + symRef.current + '/100',
      {
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        // // log(res);
        // processTopMatch(res.data);
        if (res.status === 200) setTopShow(res?.data?.reverse());
      })
      .catch((error) => {
        log(error);
      });
  }

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview"
      style={{ background: theme === 'dark' ? '#1C192C' : '#C4C4C4', borderRadius: '2px' }}
    >
      <div className="d-flex mt-2 pb-2">
        <div
          className={
            'w-50 fz-13 btn-analysis first ' +
            (tabActive === 'Tong-Hop' ? 'active' : '')
          }
          onClick={() => setTabActive('Tong-Hop')}
        >
          {t('algo.bdkt.txt-overview')}
        </div>
        <div
          className={
            'w-50 fz-13 btn-analysis ' +
            (tabActive === 'Lich-Su' ? 'active' : '')
          }
          onClick={() => setTabActive('Lich-Su')}
        >
          {t('algo.ptcp.txt-Order-book')}
        </div>
        <div
          className={
            'w-50 fz-13 btn-analysis second ' +
            (tabActive === 'Dong-Tien' ? 'active' : '')
          }
          onClick={() => setTabActive('Dong-Tien')}
        >
          {t('algo.bdkt.txt-statistical')}
        </div>
      </div>
      {tabActive === 'Tong-Hop' && (
        <PanelStockOverView
          stockDetail={stockDetail}
          basicInfo={basicInfo}
          stockRealShow={stockRealShow}
          t={t}
        />
      )}
      {tabActive === 'Lich-Su' && (
        <PanelStockTradeHistory
          symActive={stockDetail?.CompanyID}
          stockDetail={stockDetail}
          topShow={topShow}
          t={t}
          theme={theme}
        />
      )}
      {tabActive === 'Dong-Tien' && (
        <PanelStockSummary
          stockDetail={stockDetail}
          symActive={stockDetail?.CompanyID}
          algoSChart={algoSChart}
          t={t}
          theme={theme}
        />
      )}
    </div>
  );
}

export default memo(OverviewStock);
